import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60205005"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "ion-margin-vertical" }
const _hoisted_4 = { slot: "start" }
const _hoisted_5 = { class: "responsive-table" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_8 = { class: "input-cell" }
const _hoisted_9 = { class: "input-cell" }
const _hoisted_10 = { class: "ion-text-center" }
const _hoisted_11 = { class: "ion-text-center" }
const _hoisted_12 = { class: "flex-container" }
const _hoisted_13 = { class: "input-cell" }
const _hoisted_14 = { class: "flex-container" }
const _hoisted_15 = {
  key: 0,
  class: "new-row"
}
const _hoisted_16 = { class: "input-cell" }
const _hoisted_17 = { class: "input-cell" }
const _hoisted_18 = { class: "ion-text-center" }
const _hoisted_19 = { class: "ion-text-center" }
const _hoisted_20 = { class: "flex-container" }
const _hoisted_21 = { class: "input-cell" }
const _hoisted_22 = { class: "flex-container" }
const _hoisted_23 = { class: "ion-margin-vertical" }
const _hoisted_24 = { slot: "start" }
const _hoisted_25 = { class: "responsive-table" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_27 = { class: "input-cell" }
const _hoisted_28 = { class: "input-cell" }
const _hoisted_29 = { class: "input-cell" }
const _hoisted_30 = { class: "flex-container" }
const _hoisted_31 = { class: "input-cell" }
const _hoisted_32 = { class: "flex-container" }
const _hoisted_33 = {
  key: 0,
  class: "new-row"
}
const _hoisted_34 = { class: "input-cell" }
const _hoisted_35 = { class: "input-cell" }
const _hoisted_36 = { class: "input-cell" }
const _hoisted_37 = { class: "input-cell" }
const _hoisted_38 = { class: "input-cell" }
const _hoisted_39 = { class: "flex-container" }
const _hoisted_40 = {
  key: 0,
  class: "ion-margin"
}
const _hoisted_41 = { class: "ion-margin-vertical" }
const _hoisted_42 = { slot: "start" }
const _hoisted_43 = { class: "responsive-table" }
const _hoisted_44 = { class: "ion-text-center" }
const _hoisted_45 = { class: "ion-text-center" }
const _hoisted_46 = { class: "ion-text-center" }
const _hoisted_47 = { class: "ion-margin-vertical" }
const _hoisted_48 = { slot: "start" }
const _hoisted_49 = { class: "ion-margin-vertical" }
const _hoisted_50 = { class: "summary-card" }
const _hoisted_51 = { class: "flex-container" }
const _hoisted_52 = { class: "flex-container" }
const _hoisted_53 = { class: "flex-container" }
const _hoisted_54 = { class: "ion-text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_import_data_modal = _resolveComponent("import-data-modal")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_auto_fill_select = _resolveComponent("auto-fill-select")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.dataLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_ion_spinner),
          _createVNode(_component_ion_text, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('LoadingData')), 1)
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_import_data_modal, {
            crop: _ctx.cropId,
            step: "meca",
            onImportData: _ctx.handleImportData
          }, null, 8, ["crop", "onImportData"]),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category, index_category) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index_category,
                class: "ion-margin-vertical"
              }, [
                _createVNode(_component_ion_toolbar, { class: "ion-margin-vertical" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_ion_text, { class: "ion-padding-horizontal" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(category.name), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _: 2
                }, 1024),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("table", null, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('Material')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('NumberPasses')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('PercentArea')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('Delegation')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('MaterialTractorAndGNRCost')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('CUMAFlow')), 1),
                      _hoisted_6,
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('RealFlow')), 1),
                      _hoisted_7
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getActions(category.id), (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, [
                            _createVNode(_component_auto_fill_select, {
                              options: category.materials,
                              searchField: "material",
                              selected: item.material_name,
                              label: _ctx.translations[_ctx.currentLanguage].Action,
                              placeholder: _ctx.translations[_ctx.currentLanguage].Search,
                              "onUpdate:modelValue": option => _ctx.handleSelected(option, item, 'material', true)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" >")
                              ]),
                              _: 2
                            }, 1032, ["options", "selected", "label", "placeholder", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("td", _hoisted_8, [
                            _createVNode(_component_ion_input, {
                              type: "number",
                              min: "0",
                              modelValue: item.number_passes,
                              "onUpdate:modelValue": ($event: any) => ((item.number_passes) = $event),
                              modelModifiers: { number: true },
                              onIonInput: ($event: any) => (_ctx.handleDebouncedupdate($event, item)),
                              class: "ion-text-center"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onIonInput"])
                          ]),
                          _createElementVNode("td", _hoisted_9, [
                            _createVNode(_component_ion_input, {
                              type: "number",
                              min: "0",
                              max: "100",
                              modelValue: item.area,
                              "onUpdate:modelValue": ($event: any) => ((item.area) = $event),
                              modelModifiers: { number: true },
                              onIonInput: ($event: any) => (_ctx.handleDebouncedupdate($event, item)),
                              class: "ion-text-center"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onIonInput"])
                          ]),
                          _createElementVNode("td", _hoisted_10, [
                            _createVNode(_component_ion_checkbox, {
                              modelValue: item.delegation,
                              "onUpdate:modelValue": ($event: any) => ((item.delegation) = $event),
                              labelPlacement: "end",
                              onIonChange: ($event: any) => (_ctx.handleDebouncedupdate($event, item))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onIonChange"])
                          ]),
                          _createElementVNode("td", _hoisted_11, [
                            (item.cost_pro_ha)
                              ? (_openBlock(), _createBlock(_component_ion_text, {
                                  key: 0,
                                  class: "ion-text-nowrap"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.cost_pro_ha) + " " + _toDisplayString(_ctx.$t('UnitEuroProHa')), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_12, [
                              _createVNode(_component_ion_input, {
                                type: "number",
                                readonly: "true",
                                modelValue: item.cuma_flow,
                                "onUpdate:modelValue": ($event: any) => ((item.cuma_flow) = $event),
                                modelModifiers: { number: true },
                                class: "ion-text-center readonly"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('UnitMnHa')), 1)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_ion_button, {
                              color: "light",
                              onClick: ($event: any) => (_ctx.copyCumaFlow(item, true))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, { icon: _ctx.arrowForwardOutline }, null, 8, ["icon"])
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _createElementVNode("td", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createVNode(_component_ion_input, {
                                type: "number",
                                min: "0",
                                modelValue: item.real_flow,
                                "onUpdate:modelValue": ($event: any) => ((item.real_flow) = $event),
                                modelModifiers: { number: true },
                                onIonInput: ($event: any) => (_ctx.handleDebouncedupdate($event, item)),
                                readonly: item.delegation,
                                class: "ion-text-center"
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onIonInput", "readonly"]),
                              _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('UnitMnHa')), 1)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_ion_button, {
                              onClick: ($event: any) => (_ctx.deleteActionItem(item.id)),
                              color: "danger"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, { icon: _ctx.trashOutline }, null, 8, ["icon"])
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ])
                        ]))
                      }), 128)),
                      (_ctx.getNewItemByCategory(category.id))
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                            _createElementVNode("td", null, [
                              _createVNode(_component_auto_fill_select, {
                                options: category.materials,
                                searchField: "material",
                                label: _ctx.translations[_ctx.currentLanguage].Action,
                                placeholder: _ctx.translations[_ctx.currentLanguage].Search,
                                ref_for: true,
                                ref: el => { if (el) _ctx.materialRefs[category.id] = el },
                                "onUpdate:modelValue": option => _ctx.handleSelected(option, _ctx.getNewItemByCategory(category.id), 'material', false)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" >")
                                ]),
                                _: 2
                              }, 1032, ["options", "label", "placeholder", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("td", _hoisted_16, [
                              _createVNode(_component_ion_input, {
                                type: "number",
                                min: "0",
                                placeholder: "0",
                                modelValue: _ctx.getNewItemByCategory(category.id).number_passes,
                                "onUpdate:modelValue": ($event: any) => ((_ctx.getNewItemByCategory(category.id).number_passes) = $event),
                                modelModifiers: { number: true },
                                onIonInput: ($event: any) => (_ctx.updateCost(_ctx.getNewItemByCategory(category.id))),
                                class: "ion-text-center"
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onIonInput"])
                            ]),
                            _createElementVNode("td", _hoisted_17, [
                              _createVNode(_component_ion_input, {
                                type: "number",
                                min: "0",
                                max: "100",
                                modelValue: _ctx.getNewItemByCategory(category.id).area,
                                "onUpdate:modelValue": ($event: any) => ((_ctx.getNewItemByCategory(category.id).area) = $event),
                                modelModifiers: { number: true },
                                onIonInput: ($event: any) => (_ctx.updateCost(_ctx.getNewItemByCategory(category.id))),
                                class: "ion-text-center"
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onIonInput"])
                            ]),
                            _createElementVNode("td", _hoisted_18, [
                              _createVNode(_component_ion_checkbox, {
                                modelValue: _ctx.getNewItemByCategory(category.id).delegation,
                                "onUpdate:modelValue": ($event: any) => ((_ctx.getNewItemByCategory(category.id).delegation) = $event),
                                onIonChange: ($event: any) => (_ctx.updateDelegation(_ctx.getNewItemByCategory(category.id))),
                                labelPlacement: "end"
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onIonChange"])
                            ]),
                            _createElementVNode("td", _hoisted_19, [
                              (_ctx.getNewItemByCategory(category.id).cost_pro_ha)
                                ? (_openBlock(), _createBlock(_component_ion_text, {
                                    key: 0,
                                    class: "ion-text-nowrap"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.getNewItemByCategory(category.id).cost_pro_ha) + " " + _toDisplayString(_ctx.$t('UnitEuroProHa')), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_20, [
                                _createVNode(_component_ion_input, {
                                  type: "number",
                                  readonly: "true",
                                  modelValue: _ctx.getNewItemByCategory(category.id).cuma_flow,
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.getNewItemByCategory(category.id).cuma_flow) = $event),
                                  modelModifiers: { number: true },
                                  class: "ion-text-center readonly"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('UnitMnHa')), 1)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_ion_button, {
                                color: "light",
                                onClick: ($event: any) => (_ctx.copyCumaFlow(_ctx.getNewItemByCategory(category.id), false))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, { icon: _ctx.arrowForwardOutline }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _createElementVNode("td", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, [
                                _createVNode(_component_ion_input, {
                                  type: "number",
                                  min: "0",
                                  modelValue: _ctx.getNewItemByCategory(category.id).real_flow,
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.getNewItemByCategory(category.id).real_flow) = $event),
                                  modelModifiers: { number: true },
                                  readonly: _ctx.getNewItemByCategory(category.id).delegation,
                                  class: "ion-text-center"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"]),
                                _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('UnitMnHa')), 1)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_ion_button, {
                                onClick: ($event: any) => (_ctx.addActionItem(_ctx.getNewItemByCategory(category.id)))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, { icon: _ctx.addCircleOutline }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                (_ctx.errorMessage && _ctx.selectedCategory == category.id)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      ref_for: true,
                      ref: el => _ctx.errorContainers[category.id] = el,
                      class: "ion-margin"
                    }, [
                      _createVNode(_component_ion_text, { color: "danger" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
                        ]),
                        _: 1
                      })
                    ], 512))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_ion_toolbar, { class: "ion-margin-vertical" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_ion_text, { class: "ion-padding-horizontal" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('Others')), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("table", null, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('Material')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('NumberPasses')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('PercentArea')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('RealFlow')) + " " + _toDisplayString(_ctx.$t('UnitMnHa')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('Cost')) + " " + _toDisplayString(_ctx.$t('UnitEuroProHa')), 1),
                    _hoisted_26
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cropMeca.other_action_items, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, [
                          _createVNode(_component_ion_input, {
                            type: "text",
                            modelValue: item.category,
                            "onUpdate:modelValue": ($event: any) => ((item.category) = $event),
                            onIonBlur: ($event: any) => (_ctx.updateOtherActionItemData($event, item)),
                            class: "ion-text-center"
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onIonBlur"])
                        ]),
                        _createElementVNode("td", _hoisted_27, [
                          _createVNode(_component_ion_input, {
                            type: "number",
                            min: "0",
                            modelValue: item.number_passes,
                            "onUpdate:modelValue": ($event: any) => ((item.number_passes) = $event),
                            modelModifiers: { number: true },
                            onIonBlur: ($event: any) => (_ctx.updateOtherActionItemData($event, item)),
                            class: "ion-text-center"
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onIonBlur"])
                        ]),
                        _createElementVNode("td", _hoisted_28, [
                          _createVNode(_component_ion_input, {
                            type: "number",
                            min: "0",
                            max: "100",
                            modelValue: item.area,
                            "onUpdate:modelValue": ($event: any) => ((item.area) = $event),
                            modelModifiers: { number: true },
                            onIonBlur: ($event: any) => (_ctx.updateOtherActionItemData($event, item)),
                            class: "ion-text-center"
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onIonBlur"])
                        ]),
                        _createElementVNode("td", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _createVNode(_component_ion_input, {
                              type: "number",
                              min: "0",
                              modelValue: item.real_flow,
                              "onUpdate:modelValue": ($event: any) => ((item.real_flow) = $event),
                              modelModifiers: { number: true },
                              onIonBlur: ($event: any) => (_ctx.updateOtherActionItemData($event, item)),
                              class: "ion-text-center"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onIonBlur"]),
                            _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('UnitMnHa')), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            _createVNode(_component_ion_input, {
                              type: "number",
                              min: "0",
                              modelValue: item.cost,
                              "onUpdate:modelValue": ($event: any) => ((item.cost) = $event),
                              modelModifiers: { number: true },
                              onIonBlur: ($event: any) => (_ctx.updateOtherActionItemData($event, item)),
                              class: "ion-text-center"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onIonBlur"]),
                            _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('UnitEuroProHa')), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_ion_button, {
                            onClick: ($event: any) => (_ctx.deleteOtherActionItem(item.id)),
                            color: "danger"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, { icon: _ctx.trashOutline }, null, 8, ["icon"])
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ]))
                    }), 128)),
                    (_ctx.newOtherActionItem)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_33, [
                          _createElementVNode("td", _hoisted_34, [
                            _createVNode(_component_ion_input, {
                              type: "text",
                              modelValue: _ctx.newOtherActionItem.category,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newOtherActionItem.category) = $event)),
                              class: "ion-text-center"
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("td", _hoisted_35, [
                            _createVNode(_component_ion_input, {
                              type: "number",
                              min: "0",
                              modelValue: _ctx.newOtherActionItem.number_passes,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newOtherActionItem.number_passes) = $event)),
                              modelModifiers: { number: true },
                              class: "ion-text-center"
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("td", _hoisted_36, [
                            _createVNode(_component_ion_input, {
                              type: "number",
                              min: "0",
                              max: "100",
                              modelValue: _ctx.newOtherActionItem.area,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newOtherActionItem.area) = $event)),
                              modelModifiers: { number: true },
                              class: "ion-text-center"
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("td", _hoisted_37, [
                            _createVNode(_component_ion_input, {
                              type: "number",
                              min: "0",
                              modelValue: _ctx.newOtherActionItem.real_flow,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newOtherActionItem.real_flow) = $event)),
                              modelModifiers: { number: true },
                              class: "ion-text-center"
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("td", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                              _createVNode(_component_ion_input, {
                                type: "number",
                                min: "0",
                                modelValue: _ctx.newOtherActionItem.cost,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newOtherActionItem.cost) = $event)),
                                modelModifiers: { number: true },
                                class: "ion-text-center"
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('UnitEuroProHa')), 1)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_ion_button, {
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addOtherActionItem(_ctx.newOtherActionItem)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, { icon: _ctx.addCircleOutline }, null, 8, ["icon"])
                              ]),
                              _: 1
                            })
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              (_ctx.errorMessageOther)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _createVNode(_component_ion_text, { color: "danger" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.errorMessageOther), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createVNode(_component_ion_toolbar, { class: "ion-margin-vertical" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_42, [
                    _createVNode(_component_ion_text, { class: "ion-padding-horizontal" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('WorkForceCostNonDelegated')), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("table", null, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('TotalWorkingHoursNonDelegatedProHa')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('WorkingHoursCost')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('CostProHaNonDelegated')), 1)
                  ]),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_44, [
                        _createTextVNode(_toDisplayString(_ctx.cropMeca.time_non_delegated_pro_ha) + " ", 1),
                        _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('UnitHourProHa')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("td", _hoisted_45, [
                        _createTextVNode(_toDisplayString(_ctx.cropMeca.working_hour_rate) + " ", 1),
                        _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('UnitEuroProHour')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("td", _hoisted_46, [
                        _createTextVNode(_toDisplayString(_ctx.cropMeca.working_hour_cost_non_delegated_pro_ha) + " ", 1),
                        _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('UnitEuroProHa')), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createVNode(_component_ion_toolbar, { class: "ion-margin-vertical" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_48, [
                    _createVNode(_component_ion_text, { class: "ion-padding-horizontal" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('StructureCosts')), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_grid, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        size: "auto",
                        class: "flex-container"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_input, {
                            fill: "solid",
                            label: _ctx.translations[_ctx.currentLanguage].CropWorker,
                            "aria-label": _ctx.translations[_ctx.currentLanguage].CropWorker,
                            type: "number",
                            modelValue: _ctx.cropMeca.structure_cost,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.cropMeca.structure_cost) = $event)),
                            modelModifiers: { number: true },
                            class: "ion-text-center",
                            onIonBlur: _ctx.updateCropMeca
                          }, null, 8, ["label", "aria-label", "modelValue", "onIonBlur"]),
                          _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('UnitEuro')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createVNode(_component_ion_grid, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_row, { class: "ion-justify-content-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, {
                      size: "auto",
                      class: "flex-container"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, [
                            _createVNode(_component_ion_text, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('TotalMecaMaterialCost')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_input, {
                              type: "number",
                              readonly: "true",
                              modelValue: _ctx.cropMeca.material_cost_pro_ha,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.cropMeca.material_cost_pro_ha) = $event)),
                              modelModifiers: { number: true },
                              class: "ion-text-center readonly"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('UnitEuroProHa')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_52, [
                            _createVNode(_component_ion_text, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('TotalMecaWorkingHourCost')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_input, {
                              type: "number",
                              readonly: "true",
                              modelValue: _ctx.cropMeca.working_hour_cost_pro_ha,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.cropMeca.working_hour_cost_pro_ha) = $event)),
                              modelModifiers: { number: true },
                              class: "ion-text-center readonly"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('UnitEuroProHa')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_53, [
                            _createVNode(_component_ion_text, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('TotalMecaCostExcludingStructurCost')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_input, {
                              type: "number",
                              readonly: "true",
                              modelValue: _ctx.cropMeca.cost_pro_ha,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.cropMeca.cost_pro_ha) = $event)),
                              modelModifiers: { number: true },
                              class: "ion-text-center readonly"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('UnitEuroProHa')), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_54, [
            _createVNode(_component_ion_button, {
              color: "secondary",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.previousStep($event, _ctx.cropSeed)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Previous')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_ion_button, {
              color: "primary",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.nextStep($event, _ctx.cropSeed)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Next')), 1)
              ]),
              _: 1
            })
          ])
        ]))
  ]))
}